export const minimumPasswordLength = 12;
export const maximumPasswordLength = 128;
